import { Component, OnInit } from '@angular/core';
import { Globals } from './globals';
import { CountryService } from './_services/country.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(public globals: Globals, private countryService: CountryService) {
    const token = localStorage.getItem('prime-token');
    if (token) {
      this.countryService.getCountriesOld().subscribe((countries) => {
        this.globals.countriesArray = countries;
        countries.forEach((country, index, array) => {
          this.globals.countries[country.id] = country;
        });
      });
    }
  }

  ngOnInit(): void {}
}
